<div provide-parent-form *ngIf="playout">
	<div *ngIf="playout.controlBar">
		<h3>{{ 'GENERAL' | translate }}</h3>

		<bb-form-element [form]="form"
			[label]="'PLAYER' | translate"
			[helpMessage]="'HELP.PLAYOUT_PLAYER' | translate"
			[hasPublicationField]="'playerid'"
		>
			<bb-select
				[options]="playerIdOptions"
				[(ngModel)]="playout.playerid"
				name="playout-playerid"
			>
			</bb-select>
		</bb-form-element>

		<bb-form-element [form]="form"
			[label]="'SKIN_GENERATION' | translate"
			[hasPublicationField]="'skinGeneration'"
		>
			<div class="input">
				<bb-select
					[options]="skinGenerationOptions"
					[(ngModel)]="playout.skinGeneration"
					name="playout-skinGeneration"
					(ngModelChange)="playoutService.updateSkinGeneration()"
				>
				</bb-select>
				<div class="italic" *ngIf="!playout.skinGeneration && playoutService?.skinGeneration !== playoutService?.currentSkinGeneration">
					Using <strong>generation {{ playoutService?.skinGeneration }}</strong> from the publication settings.
				</div>
			</div>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'TITLE' | translate" [required]="true">
			<input
				type="text"
				name="playout-name"
				required
				[(ngModel)]="playout.name"
			/>
		</bb-form-element>

		<!-- New setting for g8 -->
		<bb-form-element [form]="form" *ngIf="playoutService?.skinGeneration >= 8" [label]="'BUTTON_TYPE' | translate">
			<bb-select [(ngModel)]="playout.centerButtonType" name="playout-centerButtonType">
				<option value="ICON">{{ 'ICON' | translate }}</option>
				<option value="ROUND">{{ 'ROUND' | translate }}</option>
				<option value="SQUARE">{{ 'SQUARE' | translate }}</option>
				<option value="BORDER">{{ 'BORDER' | translate }}</option>
				<option value="OUTLINE">{{ 'OUTLINE' | translate }}</option>
				<option value="INVERSED">{{ 'INVERSED' | translate }}</option>
			</bb-select>
		</bb-form-element>

		<!-- New setting for g8 -->
		<bb-form-element [form]="form" *ngIf="playoutService?.skinGeneration >= 8" [label]="('CORNER_RADIUS' | translate) + ' (px)'">
			<input type="number" min="0" max="15" name="playout-cornerRadius" [(ngModel)]="playout.cornerRadius" />
		</bb-form-element>

		<h3>{{ 'DIMENSIONS' | translate }}</h3>

		<bb-player-aspect-ratio *ngIf="playout"
			[(form)]="form"
			[(width)]="playout.width"
			[(height)]="playout.height"
			[(aspectRatio)]="playout.aspectRatio"
			[(responsiveSizing)]="playout.responsiveSizing"
			[defaultOption]="'USE_VIDEO_ASPECT_RATIO' | translate"
		></bb-player-aspect-ratio>
			
		<bb-form-element [label]="'MAXIMUM_WIDTH' | translate" [helpMessage]="'HELP.APPEARANCE_WIDTH' | translate">
			<bb-dimension name="playout-maxWidth" [(ngModel)]="playout.maxWidth" [units]="maxWidthUnits"
				[placeholder]="'LEAVE_BLANK_TO_DISABLE' | translate"
			></bb-dimension>
		</bb-form-element>		

		<bb-form-element *ngIf="playoutService?.skinGeneration <= 7" [form]="form" [label]="'AUTO_HEIGHT' | translate" [helpMessage]="'HELP.AUTO_HEIGHT' | translate"
			[hasPublicationField]="'autoHeight'"
		>
			<bb-check name="playout-autoHeight" [(ngModel)]="playout.autoHeight" [trueValue]="'true'" [falseValue]="'false'"></bb-check>
		</bb-form-element>

		<h3>{{ 'COLOR' | translate }}</h3>

		<bb-form-element *ngIf="playoutService?.skinGeneration <= 7" [form]="form" [label]="'BACKGROUND_OPACITY' | translate" class="input-overflow-visible">
			<div class="alpha-controlbar">
				<bb-dimension 
					[(ngModel)]="playout.alphaControlBar"
					[ngModelOptions]="{standalone: true}"
					[inputWidth]="'40px'"
					[units]="[{label: '%', value: '%'}]"
				></bb-dimension>
				<bb-slider
					name="playout-alphaControlBar"
					[(ngModel)]="playout.alphaControlBar"
					[min]="0"
					[max]="100"
					[step]="5"
					[labelFilter]="'rounded'"
					displaySuffix="%"
				></bb-slider>
			</div>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="(previewPlayer?.use2018skinSettings ? 'FOREGROUND_COLOR' : 'ACCENT_COLOR') | translate" class="input-overflow-visible">
			<bb-color-picker-box [(ngModel)]="playout.skin_foregroundColor" [pickerPosition]="'left'" [colorPresets]="usedColors" [excludeHexHash]="true" name="playout-skin_foregroundColor"></bb-color-picker-box>
		</bb-form-element>

		<!-- New setting for g8 -->
		<bb-form-element [form]="form" *ngIf="playoutService?.skinGeneration >= 8" [label]="'HIGHLIGHT_COLOR' | translate" [helpMessage]="'HELP.HIGHLIGHT_COLOR' | translate" class="input-overflow-visible">
			<bb-color-picker-box [(ngModel)]="playout.ariaFocusColor" [pickerPosition]="'left'" [colorPresets]="usedColors" [excludeHexHash]="true" name="playout-ariaFocusColor"></bb-color-picker-box>
		</bb-form-element>

		<bb-form-element *ngIf="playoutService?.skinGeneration <= 7" [form]="form" [label]="'BACKGROUND_COLOR' | translate" class="input-overflow-visible">
			<bb-color-picker-box [(ngModel)]="playout.skin_backgroundColor" [pickerPosition]="'left'" [colorPresets]="usedColors" [excludeHexHash]="true" name="playout-skin_backgroundColor"></bb-color-picker-box>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'WIDGET_COLOR' | translate" *ngIf="previewPlayer?.use2018skinSettings" class="input-overflow-visible">
			<bb-color-picker-box [(ngModel)]="playout.skin_widgetColor" [pickerPosition]="'left'" [colorPresets]="usedColors" [excludeHexHash]="true" name="playout-skin_widgetColor"></bb-color-picker-box>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PLAYOUT_BACKGROUND_COLOR' | translate" class="input-overflow-visible">
			<bb-color-picker-box [(ngModel)]="playout.bgColor" [pickerPosition]="'left'" [colorPresets]="usedColors" [excludeHexHash]="true" name="playout-bgColor"></bb-color-picker-box>
		</bb-form-element>

		<h3>{{ 'LOGO' | translate }}</h3>

		<bb-form-element [form]="form" [label]="'IMAGE' | translate">
			<bb-logo-selector name="playout-logoId" [useType]="'commercial'" [mediaTypes]="['image']" [(entityId)]="playout.logoId" (uploadedEntity)="setUploaded($event)" (entityIdChange)="changePlayoutLogo(playout?.logoId)"></bb-logo-selector>
		</bb-form-element>

		<bb-form-element [form]="form"
			*ngIf="playout.logoId"
			[label]="'ALIGNMENT' | translate"
		>
			<bb-select
				[(ngModel)]="playout.logoAlign"
				name="playout-logoAlign"
			>
				<option value="TOPRIGHT">{{ 'TOP_RIGHT' | translate }}</option>
				<option value="TOPLEFT">{{ 'TOP_LEFT' | translate }}</option>
				<option *ngIf="playoutService?.skinGeneration <= 7" value="BOTTOMLEFT">{{ 'BOTTOM_LEFT' | translate }}</option>
				<option *ngIf="playoutService?.skinGeneration <= 7" value="BOTTOMRIGHT">{{ 'BOTTOM_RIGHT' | translate }}</option>
			</bb-select>
		</bb-form-element>

		<bb-form-element [form]="form"
			[label]="'CLICK_URL' | translate"
			*ngIf="playout.logoId"
		>
			<input
				type="text"
				name="playout-logoClickUrl"
				[(ngModel)]="playout.logoClickUrl"
			/>
		</bb-form-element>
	</div>
</div>
